<button id="help-button" (click)="showHelp()" aria-label="Help">
  <i class="fa fa-question-circle" aria-hidden="true"></i>
</button>
